<template>
  <div class="layout-builder-layout-placeholder-contact-info">
    <div class="layout-builder-layout-placeholder-contact-info-top">
      <div class="layout-builder-layout-placeholder-contact-info-top-avatar" />
      <div class="layout-builder-layout-placeholder-contact-info-top-line-top" />
      <div class="layout-builder-layout-placeholder-contact-info-top-line-bottom" />
    </div>

    <div class="layout-builder-layout-placeholder-contact-info-center">
      <div class="layout-builder-layout-placeholder-contact-info-center-line-top" />
      <div class="layout-builder-layout-placeholder-contact-info-center-line-bottom" />
    </div>

    <div class="layout-builder-layout-placeholder-contact-info-bottom">
      <div class="layout-builder-layout-placeholder-contact-info-bottom-line-top" />
      <div class="layout-builder-layout-placeholder-contact-info-bottom-line-center" />
      <div class="layout-builder-layout-placeholder-contact-info-bottom-line-bottom" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'LayoutBuilderLayoutPlaceholderContactInfo',
});
</script>

<style lang="scss" scoped>
@import "../../../styles/index";

.layout-builder-layout-placeholder-contact-info {
  @include placeholder;

  height: 100%;
  gap: var(--s-6);

  &-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--s-3);

    &-avatar {
      @include placeholder-circle;

      width: 5rem;
      height: 5rem;
    }

    &-line-top {
      @include placeholder-line-primary;

      margin-top: var(--s-4);
      width: 8.125rem;
    }

    &-line-bottom {
      @include placeholder-line-secondary;

      margin-top: var(--s-3);
      width: 6rem;
    }
  }

  &-center {
    &-line-top {
      @include placeholder-line-primary;

      width: 100%;
    }

    &-line-bottom {
      @include placeholder-line-secondary;

      margin-top: var(--s-4);
      width: 50%;
    }
  }

  &-bottom {
    &-line-top {
      @include placeholder-line-primary;

      width: 100%;
    }

    &-line-center {
      @include placeholder-line-secondary;

      margin-top: var(--s-4);
      width: 50%;
    }

    &-line-bottom {
      @include placeholder-line-secondary;

      margin-top: var(--s-3);
      width: 25%;
    }
  }
}
</style>
